var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDeviceIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.996,
    height: 18.002,
    viewBox: "0 0 17.996 18.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Device_Icon_2",
    "data-name": "Device Icon 2",
    d: "M-5877.667,19318l-10.666-.039a3.631,3.631,0,0,1-3.666-3.588v-10.781a3.635,3.635,0,0,1,3.666-3.594l10.666.039a3.633,3.633,0,0,1,3.666,3.592v10.779A3.633,3.633,0,0,1-5877.667,19318Zm-7.432-5a.9.9,0,0,0-.9.9.9.9,0,0,0,.9.9h4.2a.9.9,0,0,0,.9-.9.9.9,0,0,0-.9-.9Z",
    transform: "translate(5891.998 -19299.998)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDeviceIn);
export default __webpack_public_path__ + "static/media/menu_device_in.0d8d4ab2c61478b7a213f5dd958581db.svg";
export { ForwardRef as ReactComponent };